import { Component } from '@angular/core';
import { SessionService } from '../../shared/services/session/session.service';
import { PayinService } from '../../shared/services/payin/payin.service';

@Component({
  selector: 'vit-payin',
  templateUrl: 'payin.component.html',
  styleUrls: ['payin.component.scss']
})
export class PayinComponent {

  showStakeInput: boolean = false;
  code: string = '';

  constructor(public sessionService: SessionService,
              public payinService: PayinService) {
  }

  payin(): void {
    this.payinService.payin(this.code);
  }

  back(): void {
    this.sessionService.showPayin = false;
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/punter-bar/payin/payin.component.ts